var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13183 25.3335C6.39835 25.163 5.09975 24.6423 4.22884 23.7714C2.66675 22.2094 2.66675 19.6951 2.66675 14.6668V14.0002C2.66675 8.97184 2.66675 6.4577 4.22884 4.89559C5.79095 3.3335 8.30509 3.3335 13.3334 3.3335H18.6667C23.695 3.3335 26.2093 3.3335 27.7713 4.89559C29.3334 6.4577 29.3334 8.97184 29.3334 14.0002V14.6668C29.3334 19.6951 29.3334 22.2094 27.7713 23.7714C26.2093 25.3335 23.695 25.3335 18.6667 25.3335C17.9194 25.3502 17.3242 25.407 16.7395 25.5402C15.1417 25.908 13.6621 26.7256 12.1999 27.4387C10.1165 28.4546 9.07475 28.9626 8.421 28.487C7.17033 27.5555 8.3928 24.6694 8.66675 23.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame (2).6ba415d68d4d94787132efba2e4b8877.svg";
export { ForwardRef as ReactComponent };